import React from "react";

const LoadingMembersHealths = () => (
  <span className="loading-members-health">
    {I18n.t("insights.page.loading.members_healths")}
  </span>
);

export default LoadingMembersHealths;
